<template>
	<div class="problems-subview">
		<div class="subviewOpts">
			<it-link :to="createProblemLink" class="button-link button-link-bicon"><sym-icon name="flash"></sym-icon> {{ env.msg('menu.newProblem') }}</it-link>
		</div>
		<div id="problemsSubview">
			<crm-table :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import CrmTable from "@/vue/table/CrmTable.vue";
import {addContextParams, CONTACT_REFS, ContextKey, EVENT_REFS, getIntValue, hasValue, injectContext, PROBLEM_REFS} from "@t/fd/AppContext.ts";
import {injectEnv} from "@fd/Environment.ts";
import ItLink from "@/router/ItLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const restApi = computed<string>(() => {
	let ep = "api/problems/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});

const createProblemLink = computed<string>(() => {
	let link = addContextParams('createProblem.do', ctx.value, PROBLEM_REFS);
	return link;
});

</script>

<style>

</style>